import {
  FETCH_USERROLESLIST_REQUEST,
  FETCH_USERROLESLIST_SUCCESS,
  FETCH_USERROLESLIST_FAILURE,
} from "./userRolesTypes";

const initialState = {
  loading: false,
  userRolesList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERROLESLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_USERROLESLIST_SUCCESS:
      return {
        loading: false,
        userRolesList: action.payload,
        error: "",
      };
    case FETCH_USERROLESLIST_FAILURE:
      return {
        loading: false,
        userRolesList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
